/**
 * index.js
 * © EMETL Working Group
 * 
 * @author  Andrew Berger
 * @version 1.0.0
 * @see App
 */

import React from "react"
import {
    createRoot
} from "react-dom/client"

import "@aws-amplify/ui-react/styles.css"
import App from "./App"


const container = document.getElementById("root")
const root = createRoot(container)
root.render(
    /*<React.StrictMode>*/
    <App />
    /*</React.StrictMode>*/,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
